import React from "react";
import { Link } from "gatsby";
import MoreIcon from "../../img/more-icon.png";
import Button from "../Button";
import { GTM_LEAD_UMOW_SIE } from "../../config/gtm_classes";

import "../../styles/cms.scss";

const MyArticleMoreLeadUmow = ({ link= "/kontakt", text = "", label = "Zobacz również:" }) => {
  return (
    <Link
      to={link}
      title={text}
      className={`more-link ${GTM_LEAD_UMOW_SIE}`}
    >
      <div className="more-wrapper more-wrapper--lead-umow">
        <div className="more-container">
          <img src={MoreIcon} alt={text} />
          <div className="more-content">
            <p className="label">{label}</p>
            <div>{text}</div>
          </div>
        </div>
        <div className="button-wrapper">
          <Button type="secondary">
            <span className={GTM_LEAD_UMOW_SIE}>Umów się</span>
          </Button>
        </div>
      </div>
    </Link>
  );
};

export default MyArticleMoreLeadUmow;
